// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"380":"18e5ce36","991":"18e5ce36"}[chunkId] + ".chunk.css";
};